import { FieldValues } from "react-hook-form";

import { StepperProps } from "../types";

export enum StepType {
  MULTI_SELECT = "multi_select",
  SINGLE_SELECT = "single_select",
  FIELDS = "fields",
  CUSTOM_STEP = "custom_step",
  SCHEDULE_A_CALL = "schedule_a_call",
}

export enum FieldType {
  SELECT = "select",
  TEXT = "text",
  TEXTAREA = "textarea",
  RADIO = "radio",
  AUTOCOMPLETE = "autocomplete",
  URL = "url",
  CONTENT_AREA = "content_area",
}

export interface FieldOption {
  title?: string;
  value: string;
  id: string;
  label?: string;
}
export interface Field {
  id: string;
  tooltip?: string;
  readOnly?: boolean;
  label: string | ((value: Record<string, string>) => string);
  type: FieldType;
  addNewOption?: boolean;
  inputType?: "text" | "password";
  fieldOptions?: FieldOption[] | ((value: Record<string, string>) => FieldOption[]);
  validation?: (value: string, formValues?: Record<string, string>) => string | boolean;
  showIf?: (selectedOptions: Record<string, string>) => boolean;
  required?: boolean;
  placeholder: string | ((value: Record<string, string>) => string);
  getAddOptionText?: (query: string) => string;
  renderOption?: (option: FieldOption) => React.ReactNode;
  fullWidth?: boolean;
}

export interface Option {
  id: string;
  title: string;
  value: string;
  description: string;
}

export interface BaseStep {
  id: string;
  title?: string;
  titleTooltip?: string;
  description?: string;
  sidebarDescription?: string;
  sidebarSubTitle?: string;
  sidebarTitle?: string;
  isOptional?: boolean;
  group?: string;
  ignoreValidation?: boolean;
  isNextDisabled?: boolean;
  shouldShowSkip?: (formValues: Record<string, unknown>) => boolean;
}

export interface StepWithOptions extends BaseStep {
  validation?: (value: string | string[]) => string | boolean;
  options: Option[];
  type: StepType.MULTI_SELECT | StepType.SINGLE_SELECT;
}

export interface StepWithCustomContent extends BaseStep {
  type: StepType.CUSTOM_STEP;
  getCustomContent: (formValues: Record<string, string>) => React.ReactNode;
}

export interface StepWithFields extends BaseStep {
  validation?: (value: string) => string | boolean;
  options: Field[];
  type: StepType.FIELDS;
}

export type StepT = StepWithOptions | StepWithCustomContent | StepWithFields;

export interface StepProps<T extends FieldValues>
  extends Pick<
    StepperProps<T>,
    "onStepOptionSelect" | "onSkip" | "isNextButtonLoading" | "onItemHover"
  > {
  stepNumber: number;
  step: StepT;
  totalSteps: number;
  onBack?: () => void;
  isBackButtonVisible?: boolean;
  onNext: () => void;
  isSkippable?: boolean;
  size?: "desktop" | "dialog";
  isPreview?: boolean;
  onExit?: () => void;
  layout?: "default" | "sidebar";
  overlayContent?: React.ReactNode;
  className?: string;
}

export interface HeaderProps {
  stepNumber: number;
  totalSteps: number;
  layout?: "default" | "sidebar";
  title?: string;
  titleTooltip?: string;
  size?: "desktop" | "dialog";
  description?: string;
}

export interface FooterProps {
  isBackButtonVisible?: boolean;
  onBack?: () => void;
  onNext: () => void;
  onSkip?: () => void;
  isSkippable?: boolean;
  isBackDisabled?: boolean;
  isNextDisabled?: boolean;
  isSubmit?: boolean;
  isNextButtonLoading?: boolean;
  size?: "desktop" | "dialog";
  isPreview?: boolean;
  onExit?: () => void;
}
